import React from "react";
import { SiteView } from "./SiteView";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";
import { ViewState } from "../../common/config/AppConstants";
import { ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";

export class SiteController extends React.Component {
  state = {
    pageName: "SiteController",
    pageState: PageState.IDLE,
    editLoading: true,

    //DISPLAY STATES
    viewState: ViewState.TABLE,

    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    rowCount: 10,
    settingsToggle: ToggleState.OFF,

    // DETAILS
    siteList: null,
    originalEditedSite: "",
    editedSite: null,

    hasOverlays: true
  };

  componentDidMount = async () => {
    this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.props.viewModel.createException(
      error,
      this.state.pageName,
      methodName
    );
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Site");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      this.setUpColumns();

      // SPECIFIC API CALLS GO HERE
      await this.props.viewModel.getSites();

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.props.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.props.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.props.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.siteBean = this.state.editedSite;
      externalObject.deletedBuildingList = this.state.deletedBuildingList;
      externalObject.deletedLocationist = this.state.deletedLocationList;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState(prevState => ({
        editedSite: {
          // object that we want to update
          ...prevState.editedSite, // keep all other key-value pairs
          [field]: value
        }
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  toggleOverlay = value => {
    try {
      this.props.log.info("Checking Overlays");
      if (this.state.hasOverlays) {
        this.props.log.info("Checking Overlays : true");
        if (format.isFunction(this.props.toggleTopbar)) {
          this.props.log.info("Checking Overlay Function : exists");
          this.props.toggleTopbar(value);
        }
      }
    } catch (error) {
      this.setError(false, "toggleOverlay", error);
    }
  };
  validateChanges = () => {
    try {
      if (this.state.editedSite === null) {
        this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedSite,
            this.state.editedSite
          )
        ) {
          this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedSite: null
      });
      this.toggleOverlay(ToggleState.ON);
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedSite)) {
        // ADD REQUIREDD FIELDS HERE AS APPROPRIATE
        return format.validateValues([this.state.editedSite.name]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(crudlStatus, "Site", "#/sites")
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async stayOnPage => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info(
          "Executing " +
            this.state.crudlState.value +
            " Staying[" +
            stayOnPage +
            "]"
        );

        switch (this.state.crudlState) {
          case CrudlStatus.CREATE:
            await this.addSite(stayOnPage);
            break;
          case CrudlStatus.UPDATE:
            await this.updateSite(stayOnPage);
            break;
          case CrudlStatus.DELETE:
            await this.deleteSite();
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  executeSetup = (requiredCrudlState, data) => {
    try {
      if (format.isNotNull(requiredCrudlState)) {
        this.props.log.info("Setting up " + requiredCrudlState.value);
        switch (requiredCrudlState) {
          case CrudlStatus.CREATE:
            this.createSetup();
            break;
          case CrudlStatus.UPDATE:
            this.updateSetup(data);
            break;
          case CrudlStatus.VIEW:
            this.viewSetup(data);
            break;
          case CrudlStatus.DELETE:
            this.deleteSetup(data);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeSetup", error);
    }
  };

  setUpColumns = () => {
    let localCols = [];
    //SPECIFIC COLUMNS FOR TABLE
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("postcode", "Postcode"));
    localCols.push(pr.getTableColumn("email", "Email"));

    this.setState({ tableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ columnOptions: colOptions });
  };

  columnToggle = event => {
    this.setState({ tableColumns: event.value });
  };

  createSetup = () => {
    window.scrollTo(0, 0);

    var data = {};
    data = this.additionalParseFunctions(data, CrudlStatus.CREATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.CREATE,
      editedSite: data,
      originalEditedSite: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.CREATE);
  };

  updateSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.UPDATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.UPDATE,
      editedSite: data,
      originalEditedSite: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.UPDATE);
  };

  viewSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.VIEW);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.VIEW,
      editedSite: data,
      originalEditedSite: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.VIEW);
  };

  deleteSetup = data => {
    data = this.additionalParseFunctions(data, CrudlStatus.DELETE);

    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedSite: data,
      originalEditedSite: JSON.stringify(data),
      validateState: ValidateState.DELETE
    });
    this.menuState(CrudlStatus.DELETE);
  };

  additionalParseFunctions = (data, crudlState) => {
    //TODO if required
    switch (crudlState) {
      case CrudlStatus.CREATE:
        data.buildingRequestList = [];
        break;
      case CrudlStatus.UPDATE || CrudlStatus.VIEW:
        var buildingListParsed = [];
        if (format.isNotNull(data.buildingList)) {
          data.buildingList.forEach(building => {
            var localBuilding = format.deepCopy(building);
            var locationListParsed = [];
            if (format.isNotNull(building.locationList)) {
              localBuilding.locationList.forEach(location => {
                var localLocation = format.deepCopy(location);
                localLocation.crudlStatus = CrudlStatus.UPDATE.value;
                locationListParsed.push(localLocation);
              });
            }
            localBuilding.crudlStatus = CrudlStatus.UPDATE.value;
            localBuilding.locationRequestList = locationListParsed;
            delete localBuilding.locationList;
            buildingListParsed.push(localBuilding);
          });
        }
        data.buildingRequestList = buildingListParsed;
        delete data.buildingList;
        break;
      case CrudlStatus.DELETE:
        break;
      default:
        break;
    }
    this.props.log.info(data);
    return data;
  };

  addSite = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var siteResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (siteResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateSiteList(
          siteResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentSite(
          siteResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  updateSite = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var siteResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (siteResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateSiteList(
          siteResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentSite(
          siteResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteSite = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var siteResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (siteResponse.errorCode === 0) {
      await this.updateSiteList(
        siteResponse,
        CrudlStatus.DELETE,
        stateVariables
      );
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  updateSiteList = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    //PLEASE HELP THIS IS AWFUL
    await this.delay(1000);
    await this.props.viewModel.getSites();

    this.setState({
      viewState: ViewState.TABLE,
      crudlState: CrudlStatus.LIST,
      validateState: ValidateState.NONE,
      editedSite: null
    });

    this.toggleOverlay(ToggleState.ON);
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  //VERY VERY TEMPORARY SOLUTION_DREADFUL
  wait = ms => {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  };
  delay = ms => new Promise(res => setTimeout(res, ms));

  updateCurrentSite = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    //PLEASE HELP THIS IS AWFUL
    await this.delay(2000);
    var siteList = await this.props.viewModel.getSitesReturned();
    var site = {};
    if (format.isNotNull(siteList)) {
      siteList.forEach(element => {
        if (element.id === apiResponse.id) {
          site = format.deepCopy(element);
        }
      });
    }
    this.updateSetup(site);
    this.setState({ siteList: siteList });
    this.setState({ pageState: PageState.IDLE });
  };
  removeBuilding = bean => {
    var localPartList = format.deepCopy(
      this.state.editedSite.buildingRequestList
    );
    var updatedLocalPartList = [];
    var deletedBuildingList = format.deepCopy(this.state.deletedBuildingList);
    if (!format.isNotNull(deletedBuildingList)) {
      deletedBuildingList = [];
    }

    localPartList.forEach(element => {
      if (element.id === bean.id) {
        if (bean.crudlStatus === CrudlStatus.UPDATE.value) {
          deletedBuildingList.push(element);
        }
      } else {
        updatedLocalPartList.push(element);
      }
    });

    this.setState({ deletedBuildingList: deletedBuildingList });
    this.updateBean("buildingRequestList", updatedLocalPartList);
  };

  addBuilding = () => {
    var buildingBean = {};
    buildingBean.name = "";
    buildingBean.description = "";
    buildingBean.crudlStatus = CrudlStatus.CREATE.value;
    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
    buildingBean.id = rand;

    let updatedList = format.deepCopy(
      this.state.editedSite.buildingRequestList
    );
    if (!format.isNotNull(updatedList)) {
      updatedList = [];
    }
    console.log(updatedList);
    updatedList.push(buildingBean);

    this.updateBean("buildingRequestList", updatedList);
  };

  removeLocation = bean => {
    var deletedLocationList = format.deepCopy(this.state.deletedLocationList);
    if (!format.isNotNull(deletedLocationList)) {
      deletedLocationList = [];
    }

    var buildingRequestList = format.deepCopy(
      this.state.editedSite.buildingRequestList
    );
    buildingRequestList.forEach(building => {
      if (building.id === bean.buildingId) {
        var updatedLocalPartList = [];
        building.locationRequestList.forEach(location => {
          if (location.id === bean.id) {
            if (bean.crudlStatus === CrudlStatus.UPDATE.value) {
              deletedLocationList.push(location);
            }
          } else {
            updatedLocalPartList.push(location);
          }

          building.locationRequestList = updatedLocalPartList;
        });
      }
    });

    this.setState({ deletedLocationList: deletedLocationList });
    this.updateBean("buildingRequestList", buildingRequestList);
  };

  addLocation = buildingBean => {
    console.log(buildingBean);
    var locationBean = {};
    locationBean.name = "";
    locationBean.description = "";
    locationBean.crudlStatus = CrudlStatus.CREATE.value;
    locationBean.buildingId = buildingBean.id;
    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
    locationBean.id = rand;

    var buildingRequestList = format.deepCopy(
      this.state.editedSite.buildingRequestList
    );
    buildingRequestList.forEach(element => {
      if (element.id === buildingBean.id) {
        let updatedList = format.deepCopy(element.locationRequestList);
        if (!format.isNotNull(updatedList)) {
          updatedList = [];
        }
        console.log(updatedList);
        updatedList.push(locationBean);
        element.locationRequestList = updatedList;
      } else {
        console.log("didnt match");
      }
    });

    this.updateBean("buildingRequestList", buildingRequestList);
  };

  render() {
    return (
      <React.Fragment>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {/*VERY VERY BAD ERROS ONLY eg PAGE LOAD*/}
        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <SiteView
            //STATE + HELPER VALUES
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            loading={this.state.pageState === PageState.LOADING}
            updateState={this.updateState}
            refresh={this.setPageData}
            //CARD SPECIFIC PROPS
            editedObject={this.state.editedSite}
            siteTypeOptions={this.state.siteTypeOptions}
            updateEdited={this.updateBean}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            buildingExpandedRows={this.state.buildingExpandedRows}
            addBuilding={this.addBuilding}
            removeBuilding={this.removeBuilding}
            addLocation={this.addLocation}
            removeLocation={this.addLocation}
            //TABLE SPECIFIC PROPS
            crudlControl={this.executeSetup}
            siteList={this.state.siteList}
            expandedRows={this.state.expandedRows}
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.columnOptions}
            columnToggle={this.columnToggle}
            tableReference={this.state.tableReference}
            rowCount={this.state.rowCount}
            settingsToggle={this.state.settingsToggle}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sites/SiteController.js